





























import { Component, Vue } from 'vue-property-decorator';
import { Property, PropertiesApi } from 'performo-api';
import { User } from 'oidc-client';

@Component({
  components: {}
})
export default class PerformoFooter extends Vue {
  // private propertyApi: PropertiesApi = new PropertiesApi(this.$store.getters.getApiConfiguration);
  get reqHelperName() {
    return this.property.reqHelpName
      ? this.property.reqHelpName
      : this.property.propertyName;
  }
  get afterHoursPhone() {
    return this.property.reqHelpPhone;
  }
  get maintenanceEmail() {
    return this.property.reqHelpEmail;
  }

  get property(): Property {
    return this.$store.getters.currentProperty;
  }

  get propertyApi(): PropertiesApi {
    return this.$store.getters.propertiesApi;
  }

  get user(): User {
    return this.$store.state.user;
  }

  private userHasInterface(interfaceName: string): boolean {
    if (!this.user.profile) {
      return false;
    } // bail out if we can't read the profile object
    if (Array.isArray(this.user.profile.interface)) {
      return this.user.profile.interface.includes(interfaceName);
    }
    return this.user.profile.interface === interfaceName;
  }
}
